import React, { Component, Suspense, lazy } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { withStyles, Fade } from '@material-ui/core';
import hubAPI from '../../../services/hubAPI';
import HUBContext from '../../../services/HUBContext'
import IndicatorSimpleCircle from './../../Dash/components/v2/indicatorSimpleCircle';
import { Row, Col } from 'antd';
import { withRouter } from 'react-router-dom'

const styles = theme => ({
    slide: { width: '100%' }
});

class AlertsResume extends Component {
    state = {
        companyID: this.context.company?.companyID || 0,
        selectedIds: [1, 2, 3],
        autoLoad: false,
        localCounter: [],
        additionalClassName: ''
    }

    componentDidMount() {
        const { selectedIds, autoLoad, setSelectedIds, widget } = this.props;
        const { companyID } = this.context;

        this.setState({ 
            selectedIds: !!setSelectedIds ? selectedIds || [] : this.state.selectedIds, 
            autoLoad: !!autoLoad, 
            companyID

        }, () => {
            if (!!autoLoad)
                this.getData();
        });

        if (!!widget) {
            const divisor = document.getElementById(`wid-${widget?.dashboardWidgetID ?? 0}`).parentElement;
            divisor.addEventListener('resize', this.onResize)

            function checkResize(mutations) {
                const el = mutations[0].target
                const w = el.clientWidth
                const h = el.clientHeight
    
                const isChange = mutations
                    .map(m => `${m.oldValue}`)
                    .some(prev => prev.indexOf(`width: ${w}px`) === -1 || prev.indexOf(`height: ${h}px`) === -1)
    
                if (!isChange) return
                const event = new CustomEvent('resize', { detail: { width: w, height: h } })
                el.dispatchEvent(event)
            }
    
            const observer = new MutationObserver(checkResize)
            observer.observe(divisor, { attributes: true, attributeOldValue: true, attributeFilter: ['style'] })
        }
    }

    componentDidUpdate() {
        const { selectedIds, autoLoad, setSelectedIds } = this.props;
        const { companyID } = this.context;

        if (!!setSelectedIds) {
            if (selectedIds !== this.state.selectedIds) {
                this.setState({ selectedIds }, () => { if (!!autoLoad) this.getData(); });
            }
        }
        if (autoLoad !== this.state.autoLoad) {
            this.setState({ autoLoad }, () => { if (!!autoLoad) this.getData(); });
        }
        if (companyID !== this.state.companyID) {
            this.setState({ companyID }, () => { if (!!autoLoad) this.getData(); });
        }
    }

    componentWillUnmount() {
        const { widget } = this.props;
        if (!!widget) {
            const divisor = document.getElementById(`wid-${widget?.dashboardWidgetID ?? 0}`).parentElement;
            divisor.removeEventListener('resize', this.onResize)
        }
    }

    getData = () => {
        const { companyID } = this.state;
        const { locale } = this.context;

        if (companyID === 0) return;

        hubAPI.get(`/api/v1/Company/${companyID}/alertevent?culture=${locale || 'en-US'}`)
            .then(response => {
                this.setState({ localCounter: response.data.additionalData.counter });
            });
    }

    onResize = (event) => {
        this.setState({ additionalClassName: event.detail.width > 1000 ? 'two-inline' : '' });
    }

    render() {
        const { company, companyID, filterCatalogs } = this.context;
        let { selectedIds, autoLoad, localCounter, additionalClassName } = this.state;
        const { counter, setSelectedIds, redirect, history } = this.props;

        if (!filterCatalogs) return null;
        if (!company || companyID == 0) return null;
        
        const circles = (filterCatalogs?.alertPriorities || []).map((alertPriority, _) => {
            const className = alertPriority.alertPriorityID === 1 ? `red ${selectedIds.indexOf(alertPriority.alertPriorityID) >= 0 ? 'checked' : ''}` :
                                alertPriority.alertPriorityID === 2 ? `yellow ${selectedIds.indexOf(alertPriority.alertPriorityID) >= 0 ? 'checked' : ''}` :
                                alertPriority.alertPriorityID === 3 ? `green ${selectedIds.indexOf(alertPriority.alertPriorityID) >= 0 ? 'checked' : ''}` : '';
            const widget = {
                title: alertPriority.name,
                className,
                checked: selectedIds.indexOf(alertPriority.alertPriorityID) >= 0,
                numberFormat: {
                    style: 'decimal',
                    useGrouping: true,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                },
                datax:{
                    parse: {
                        datasets: {
                            currentValue: (!!autoLoad ? (localCounter || []) : (counter || [])).find(x => x.alertPriorityID === alertPriority.alertPriorityID)?.counter || 0
                        }
                    }
                },
                onClick: () => {
                    if (!!redirect) {
                        history.push(`/app/${company?.companyID || 0}/alertevents?alertPriorityID=${alertPriority.alertPriorityID}`);
                    }
                    else {
                        const isChecked = selectedIds.indexOf(alertPriority.alertPriorityID) >= 0;
                        if (isChecked)
                            selectedIds = selectedIds.filter(x => x !== alertPriority.alertPriorityID);
                        else
                            selectedIds.push(alertPriority.alertPriorityID);
                        
                        this.setState({ selectedIds }, () => {
                            if (!!setSelectedIds)
                                setSelectedIds(selectedIds);
                        });
                    }
                }
            }

            return <Fade in={true} timeout={1000} key={alertPriority.alertPriorityID}>
                <Col span={8}>
                    <IndicatorSimpleCircle widget={widget} className={className} data={widget.datax} />
                </Col>
            </Fade>
        });

        return <div className={`dashboard-area alerts-resume ${this.props.className || ''} ${additionalClassName}`}>
            <div className='widget-container'>
                <div className='widget' style={{ marginBottom: '0px' }}>
                    <div className='content-area'>
                        <Row>
                            { circles }
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    }
}

AlertsResume.contextType = HUBContext;
AlertsResume = withRouter(AlertsResume);
AlertsResume.propTypes = { classes: PropTypes.object.isRequired };
export default withStyles(styles)(injectIntl(AlertsResume));